"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pace-del-mela": {
    "4227654c": [{
      "hkey": "74165016",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "camastra": [{
      "hkey": "74165016",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pace-del-mela"
    }],
    "42c53c0a": [{
      "hkey": "fdbd00cc",
      "slug": "pace-del-mela",
      "name": "Pace del Mela",
      "primary": true,
      "skipSearch": false
    }],
    "gabbia": [{
      "hkey": "fdbd00cc",
      "slug": "pace-del-mela",
      "name": "Pace del Mela",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;